import React from "react";
import {
  Dialog,
  Dropdown,
  DropdownOption,
  Icon,
} from "@abb/abb-common-ux-react";
import Utility from "../shared/Utility";
import * as CONSTANTS from "../../utilities/Constants";

import {
  ChartTypes,
  DateUnits,
  ISeries,
  ITrendDataLimit,
  Trend,
  TrendMarkerTypes,
} from "@iom/trend";
import _ from "lodash";
import utility from "../shared/Utility";
import NoTrendToDisplay from "../shared/NoTrendToDisplay";
import { Translation } from "react-i18next";
import { Status } from "../../models/sample/Status";
import { ABB_CARET_DOWN, ABB_CARET_UP } from "../../utilities/IconConstants";
import triggerNotifications from "../../utilities/TriggerNotifications";
import measurementSettingStore from "../../flux/stores/settings/MeasurementSettingStore";

interface ILandingprops {
  showInstrumentProperty?: (data: any) => void;
  showInstrumentPropertyDetails?: (data: any) => void;
  selectedInstrumentDetail: any;
  selectedDirection: any;
  selectedPosition: any;
  thresholdSettings: any;
  startInstrumentMeasurement: (event: any, instrumentId: string) => void;
  stopInstrumentMeasurement: (event: any, instrumentId: string) => void;
  resumeInstrumentMeasurement: (event: any, instrumentId: string) => void;
  remeasureInstrumentMeasurement: (event: any, instrumentId: string) => void;
  reMeasureDirectionPositionCount: (
    instumentId: string,
    directionId: string,
    position: any,
    count: any,
    isFromPositions: boolean
  ) => void;
  reMeasureDirectionPositionCountSingleAll: (
    instumentId: string,
    directionId: string,
    position: any,
    count: any,
    directionIddummy: string[],
    countdummy: number[]
  ) => void;
  reMeasureDirectionPositionCountAll: (
    instumentId: string,
    directionId: string[],
    position: any,
    count: number[]
  ) => void;
  skipCountInPosition: (
    InstumentId: string,
    Position: number,
    direction: string,
    count: number[]
  ) => void;
  endPosition: (InstumentId: string, Position: number) => void;
  testPlan: any;
  activeItem: any;
  onRemeasureClick: any;
}

interface IPropertyValueState {
  valueStatus: boolean;
  toggleGraph: boolean;
  searchValue: string;
  selectedDirection: any;
  dropdownDirectionOptions: any;
  activeDirectionIndx: number;
  showPositionCountRemasure: boolean;
  reMeasureDirection: any;
  reMeasureCount: any;
}

export default class InstrumentPropertyDetails extends React.Component<
  ILandingprops,
  any
> {
  private _All = "All";
  private _defaultDirection = [{ value: this._All, label: this._All }];

  private start = new Date(2019, 0, 1, 0, 0, 0, 0);
  private end = new Date(2019, 0, 5, 0, 0, 0, 0);
  private minXValue: number;
  private maxXValue: number;
  private _autolineScroll: any;
  private _mount: boolean;
  private _hasData: boolean = true;
  private _page: any = 1;

  constructor(props: any) {
    super(props);

    this._autolineScroll = React.createRef();

    this.minXValue = 0;
    this.maxXValue = 200;

    this.state = {
      activeDirectionIndx: [],
      showPositionCountRemasure: false,
      showSkipCount: false,
      reMeasureDirection: [],
      reMeasureCount: [],
      skipCountsDetails: [],
      valueStatus: true,
      toggleGraph: false,
      searchValue: "",
      dropdownDirectionOptions: [
        ...this._defaultDirection,
        ...props.selectedInstrumentDetail.allDirections.map((data: any) => {
          return { value: data.id, label: data.name };
        }),
      ],
      chartType: "Bar",
      dateUnit: "Day",
      dateUnitCount: 4,
      start: this.start,
      end: this.end,
      series: [
        {
          name: "Position",
          color: "#5ABFAE",
          id: "1",
          markerStyle: {
            type: this.state?.chartType === "Bar" ? "None" : "Circle",
          },
          yAxis: {
            min: this.minXValue,
            max: this.maxXValue,
            decimalPlaces: 0,
          },
          isShownInChart: true,
          points: this.generateOrdinalData1(0, 20, 1, 0, 100), // String
        },
      ],
    };
  }

  componentWillReceiveProps(
    nextProps: Readonly<ILandingprops>,
    nextContext: any
  ): void {
    if (
      nextProps.selectedInstrumentDetail &&
      nextProps.selectedInstrumentDetail.nextMeasuringPositionDireaction &&
      nextProps.selectedInstrumentDetail.nextMeasuringPositionDireaction
        .directionId
    ) {
      if (
        nextProps.selectedInstrumentDetail.id !==
        this.props.selectedInstrumentDetail.id
      ) {
        this.setState({
          activeDirectionIndx: [
            nextProps.selectedInstrumentDetail.nextMeasuringPositionDireaction
              .directionId,
          ],
          showSkipCount: false,
          showPositionCountRemasure: false,
        });
      } else {
        if (
          this.state.activeDirectionIndx &&
          (this.state.activeDirectionIndx.length > 1 ||
            !this.state.activeDirectionIndx.includes(
              nextProps.selectedInstrumentDetail.nextMeasuringPositionDireaction
                .directionId
            ))
        ) {
          this.setState({
            activeDirectionIndx: [
              nextProps.selectedInstrumentDetail.nextMeasuringPositionDireaction
                .directionId,
            ],
          });
        }
      }
    }
  }

  componentDidMount(): void {
    const activeDirectionIndx: any = [];

    if (
      this.props.selectedInstrumentDetail &&
      this.props.selectedInstrumentDetail.nextMeasuringPositionDireaction &&
      this.props.selectedInstrumentDetail.nextMeasuringPositionDireaction
        .directionId
    ) {

      activeDirectionIndx.push(
        this.props.selectedInstrumentDetail.nextMeasuringPositionDireaction
          .directionId
      );

      this.setState({ activeDirectionIndx });
      const directionHeight = window.document.getElementById("directionRow");
      const indexVal =
        this.props.selectedInstrumentDetail.allDirections.findIndex(
          (el: any) =>
            el.id ===
            this.props.selectedInstrumentDetail.nextMeasuringPositionDireaction
              .directionId
        );
      if (directionHeight && indexVal > -1) {
        const scrollVal = indexVal * directionHeight.offsetHeight;
        const element = window.document.getElementById("tableScroll");
        setTimeout(() => {
          element.scrollTop = scrollVal + 30;
        }, 500);
      }
    }
    else if (activeDirectionIndx && activeDirectionIndx?.length <= 0) {
      activeDirectionIndx.push(this.props.selectedInstrumentDetail?.allDirections[0]?.id);
    }
    this.setState({ activeDirectionIndx });
    this.setState({
      chartType: measurementSettingStore.getChartType(),
    });
  }
  generateOrdinalData1(
    fromDate: number,
    toDate: number,
    interval = 1,
    min: number,
    max: number,
    isNumber = false
  ) {
    const data = [
      {
        xValue: "Position",
        value: 50,
      },
    ];
    return data;
  }

  onChartTypeChange = (chartType: ChartTypes) => {
    this.setState({
      chartType: chartType,
    });
    return chartType;
  };

  onSeriesChartTypeChange = (value: string, series: ISeries) => {
    let updatedValue: ISeries[] = this.state.series.map((item: any) => {
      if (item.name === series.name) {
        return { ...item, chartType: value } as ISeries;
      } else {
        return item;
      }
    });
    this.setState({ series: updatedValue });
  };

  onSeriesColorChange = (value: string, series: ISeries) => {
    let updatedValue: ISeries[] = this.state.series.map((item: any) => {
      if (item.name === series.name) {
        return { ...item, color: value } as ISeries;
      } else {
        return item;
      }
    });
    this.setState({ series: updatedValue });
  };

  getMarkerStyles = (value: string, item: ISeries) => {
    let marker = item.markerStyle ? { ...item.markerStyle } : {};
    if (value === "Circle") {
      marker.type = "Circle";
      marker.fillColor = "white";
    } else if (value === "Square") {
      marker.type = "Square";
      marker.fillColor = "white";
    } else if (value === "FillCircle") {
      marker.type = "Circle";
      marker.fillColor = "SeriesColor";
    } else if (value === "FillSquare") {
      marker.type = "Square";
      marker.fillColor = "SeriesColor";
    } else {
      marker.type = "None";
    }
    return marker;
  };

  onSeriesMarkerChange = (value: TrendMarkerTypes, series: ISeries) => {
    let updatedValue: ISeries[] = this.state.series.map((item: any) => {
      if (item.name === series.name) {
        return {
          ...item,
          markerStyle: { ...series.markerStyle, type: value },
        } as ISeries;
      } else {
        return item;
      }
    });
    this.setState({ series: updatedValue });
  };

  onSeriesFillTypeChange = (value: string, series: ISeries) => {
    let updatedValue: ISeries[] = this.state.series.map((item: any) => {
      if (item.name === series.name) {
        return { ...item, fillType: value } as ISeries;
      } else {
        return item;
      }
    });
    this.setState({ series: updatedValue });
  };

  onInvalidPointTypeChange = (value: string, series: ISeries) => {
    let updatedValue: ISeries[] = this.state.series.map((item: any) => {
      if (item.name === series.name) {
        return { ...item, invalidPointLineType: value } as ISeries;
      } else {
        return item;
      }
    });
    this.setState({ series: updatedValue });
  };

  onDateRangeChange = (
    start: string | number | Date,
    end: string | number | Date,
    dateUnit: DateUnits,
    dateUnitCount: number,
    isOnZoom: boolean
  ) => {
    this.setState({
      dateUnit,
      dateUnitCount,
      start: start as Date,
      end: end as Date,
    });
  };

  onDataLimitVisibilityChange = (
    series: ISeries,
    limit: ITrendDataLimit,
    isShown: boolean
  ) => {
    let updatedValue = this.state.series.map((item: any) => {
      if (item.name === series.name) {
        let limits = item.dataLimits.map((line: ITrendDataLimit) => {
          if (line.name === limit.name) {
            return { ...line, shownInChart: isShown };
          } else {
            return line;
          }
        });
        return { ...item, dataLimits: limits };
      } else {
        return item;
      }
    });

    this.setState({ series: updatedValue });
  };

  /// Get right color to show in dashboard screen.
  /// Dashboard measurement statistics will not have direct value status, so need to pick right color by looking in all available positions
  /// default color is black
  private getRightColorForDashboardView(
    allValueRangesForAPosition: any[]
  ): string {
    let color = CONSTANTS.WITHIN_LIMIT_COLOR;
    if (
      allValueRangesForAPosition?.filter(
        (x) => x?.valueRange?.name === CONSTANTS.ValueRange.AlarmLimit1
      )?.length > 0
    ) {
      color = this.props.thresholdSettings.find(
        (x: any) => x.name === "Alarm Limit1"
      )?.colorCode;
    } else if (
      allValueRangesForAPosition?.filter(
        (x) => x?.valueRange?.name === CONSTANTS.ValueRange.AlarmLimit2
      )?.length > 0
    ) {
      color = this.props.thresholdSettings.find(
        (x: any) => x.name === "Alarm Limit2"
      )?.colorCode;
    } else if (
      allValueRangesForAPosition?.filter(
        (x) => x?.valueRange?.name === CONSTANTS.ValueRange.RejectLimit
      )?.length > 0
    ) {
      color = this.props.thresholdSettings.find(
        (x: any) => x.name === "Reject Limit"
      )?.colorCode;
    } else if (
      allValueRangesForAPosition?.filter(
        (x) => x?.valueRange?.name === CONSTANTS.ValueRange.WithinLimit
      )?.length > 0
    ) {
      color = CONSTANTS.WITHIN_LIMIT_BG_COLOR;
    }
    return color;
  }
  // MEASURED END

  /**
   * Function that greets a user
   * @author   Sheetal
   * @param    {String} name    Name of the user
   * @return   {String}         Greeting message
   */
  toggleGraphView = () => {
    this.setState({
      toggleGraph: !this.state.toggleGraph,
    });
  };

  private searchHandler = (e: any) => {
    const value = e.target.value;
    this.setState({
      searchValue: value,
    });
  };

  private onSetActiveDirectionIndx = (id: string) => {
    const activeDirectionIndx = [...this.state.activeDirectionIndx];
    if (activeDirectionIndx.includes(id.toString().trim())) {
      const index = activeDirectionIndx.indexOf(id);
      if (index > -1) {
        activeDirectionIndx.splice(index, 1);
      }
    } else {
      activeDirectionIndx.push(id);
    }
    this.setState({ activeDirectionIndx });
  };

  // MEASURED START
  public createMeasuredColumns = () => {
    const items: any[] = [];
    const countData = this.props.selectedInstrumentDetail?.countData.find(
      (x: any) => x.selected
    );
    if (countData !== undefined) {
      const directions = countData.directions.find((x: any) => x.selected);
      for (let index = 1; index <= directions?.maxCount; index++) {
        items.push(
          <th scope="col" key={index}>
            {index}
          </th>
        );
      }
    }

    return items;
  };

  private createMeasuredColumnData = (
    propertyToDisplay: any,
    fulllength: any,
    currentlength: any,
    isMeasuring: boolean,
    directionID?: string
  ) => {
    const items: any[] = [];
    let countData = this.props.selectedInstrumentDetail.countData.find(
      (x: any) => x.position === this.props.selectedPosition.position
    );
    if (!countData) {
      countData = this.props.selectedInstrumentDetail.countData[0];
    }
    let selectedDirection: any;
    if (countData !== undefined) {
      selectedDirection = directionID
        ? countData.directions.find((x: any) => x.id === directionID)
        : countData.directions.find((x: any) => x.selected);
    }
    let selectedPosition =
      this.props.selectedInstrumentDetail.positionCount.find(
        (x: any) => x.selected
      );
    if (!selectedPosition) {
      selectedPosition = this.props.selectedInstrumentDetail.positionCount[0];
    }

    let properties = [];
    const filteredProps = Utility.getUniquePropertiesFromList(
      this.props.selectedInstrumentDetail.properties
    );

    properties = filteredProps.filter((x) => {
      if (selectedDirection !== undefined) {
        if (selectedDirection.name === "All") {
          return x;
        } else {
          return x.directionId === selectedDirection.id;
        }
      } else {
        if (x.name === "All") {
          return x;
        } else {
          return x;
        }
      }
    });

    properties = properties.filter(
      (x: any) =>
        x.id === propertyToDisplay.id &&
        x.directionId === propertyToDisplay.directionId
    );

    if (selectedPosition !== undefined) {
      properties.map((data: any, index) => {
        const isProperty =
          this.props.selectedInstrumentDetail.positionMeans.filter(
            (el: any) =>
              el.directionId === data.directionId &&
              el.propertyId === data.id &&
              el.position === this.props.selectedPosition.position
          );
        if (isProperty && isProperty.length) {
          items.push(
            <td className="property val" style={{ minWidth: "100px" }}>
              <span>
                {!isNaN(isProperty[0].mean) &&
                  isProperty[0].mean !== null &&
                  isProperty[0].mean !== undefined
                  ? `(${isProperty[0].mean?.toFixed(
                    propertyToDisplay?.decimals
                  )})`
                  : CONSTANTS.NOTCONSIDEREDFORCALC}
              </span>
            </td>
          );
        } else {
          items.push(
            <td className="property val" style={{ minWidth: "100px" }}>
              <span>{CONSTANTS.NOTCONSIDEREDFORCALC}</span>
            </td>
          );
        }
        const cpProperty =
          this.props.selectedInstrumentDetail.currentMeasuringProperty;
        const cpPosition =
          this.props.selectedInstrumentDetail.currentMeasuringPosition;

        items.push(
          this.createData(
            data.id,
            data.name,
            selectedDirection,
            this.props.selectedPosition,
            data.directionId,
            cpPosition,
            fulllength,
            currentlength,
            isMeasuring
          )
        );
      });
    }
    return items;
  };

  public createData(
    propertyId: any,
    propertyName: string,
    selectedDirection: any,
    selectedPosition: any,
    directionId?: string,
    cpPosition?: number,
    fulllength?: number,
    currentlength?: number,
    isMeasuring?: boolean
  ) {
    const items: any[] = [];
    if (selectedDirection !== undefined) {
      for (let index = 0; index < selectedDirection?.maxCount; index++) {
        const readings = this.props.selectedInstrumentDetail.readings;
        // // properties and directionCounts
        let dirC: any[] = [];
        if (selectedDirection.name === "All") {
          dirC = this.props.selectedInstrumentDetail.directionCounts.filter(
            (x: any) =>
              x.position === selectedPosition.position &&
              x.direction.id == directionId
          );
        }
        let indexNumber = 0;
        dirC.map((element: any) => {
          const checkDirection = propertyName.search(element.direction.name);
          if (checkDirection !== -1) {
            indexNumber = element.totalCounts;
          }
        });
        let mainData;
        if (readings.length > 0) {
          if (selectedDirection.name === "All") {
            if (this.props.selectedInstrumentDetail.isAutoLine) {
              const countData =
                this.props.selectedInstrumentDetail.countData.find(
                  (x: any) => x.selected === true
                );
              const dirCount =
                this.props.selectedInstrumentDetail.directionCounts.find(
                  (x: any) => x.name === countData?.positionName
                );
              this.props.selectedInstrumentDetail.readings.map((x: any) => {
                if (
                  x.propertyId === propertyId &&
                  x.count === index + 1 &&
                  x.position === dirCount.position &&
                  x.positionName === dirCount.name
                ) {
                  mainData = x;
                }
              });
            } else {
              mainData = readings.find(
                (x: any) =>
                  x.count === index + 1 &&
                  x.propertyId === propertyId &&
                  x.position === selectedPosition.position &&
                  x.directionId === directionId
              );
            }
          } else {
            mainData = readings.find(
              (x: any) =>
                x.count === index + 1 &&
                x.propertyId === propertyId &&
                x.directionId === selectedDirection.id &&
                x.position === selectedPosition.position
            );
          }
        }

        const data =
          mainData !== undefined &&
            mainData.value != null &&
            mainData?.positionName?.toLowerCase() === this.props.selectedPosition?.positionName?.toLowerCase() &&
            !isNaN(mainData.value)
            ? mainData.value.toFixed(mainData.decimals)
            : indexNumber <= index
              ? CONSTANTS.NOTCONSIDEREDFORCALC
              : CONSTANTS.NOTCONSIDEREDFORCALC;
        let color = "black";
        if (mainData !== undefined) {
          if (mainData.valueRange.name === "Alarm Limit1") {
            color = this.props.thresholdSettings.find(
              (x: any) => x.name === "Alarm Limit1"
            )?.colorCode;
          } else if (mainData.valueRange.name === "Alarm Limit2") {
            color = this.props.thresholdSettings.find(
              (x: any) => x.name === "Alarm Limit2"
            )?.colorCode;
          } else if (mainData.valueRange.name === "Reject Limit") {
            color = this.props.thresholdSettings.find(
              (x: any) => x.name === "Reject Limit"
            )?.colorCode;
          } else if (mainData.valueRange.name === "Within Limit") {
            color = CONSTANTS.WITHIN_LIMIT_BG_COLOR;
          }
        }

        let secondaryClassName: string = "";

        let isActiveIndication: boolean = false;

        if (
          this.props.selectedInstrumentDetail &&
          this.props.selectedInstrumentDetail.nextMeasuringPositionDireaction &&
          this.props.selectedInstrumentDetail.nextMeasuringPositionDireaction
            .position === this.props.selectedPosition.position &&
          this.props.selectedInstrumentDetail.nextMeasuringPositionDireaction
            .directionId === directionId &&
          this.props.selectedInstrumentDetail.nextMeasuringPositionDireaction
            .count ===
          index + 1
        ) {
          isActiveIndication = true;
          if (currentlength === 0) {
            secondaryClassName = "border-top-box";
          } else if (fulllength === currentlength + 1) {
            secondaryClassName = "border-bottom-box";
          }
        }

        items.push(
          <td
            className={
              isActiveIndication && isMeasuring
                ? `normal-class text-align-center col box-border ${secondaryClassName}`
                : `normal-class text-align-center`
            }
            style={{ minWidth: "100px" }}
            key={index}
          >
            <span className="mix-blend-color" style={{ background: data !== "(--)" ? color : "transparent" }}>
              <span style={{ color: data !== "(--)" ? utility.pickTextColorBasedOnBgColorAdvanced(color, '#FFFFFF', '#000000') : color }}>{data}</span>
            </span>
          </td>
        );
      }
    }

    return items;
  }
  // MEASURED END .filter(x => selectedDirection.name === "All" ? x : x.directionId === selectedDirection.id);

  private measuredRow() {
    const items: any[] = [];
    const selectedInstrumentDetail = this.props.selectedInstrumentDetail;
    let selectedDirectionCount: any[] = []
    selectedInstrumentDetail.directionCounts.map((item: any) => {
      if (this.props.selectedPosition.position === item.position) {
        selectedDirectionCount.push({
          id: item.direction.id,
          name: item.direction.name,
          order: item.direction.order,
        });
      }
    })
    selectedDirectionCount = selectedDirectionCount?.sort((a, b) => { return a.order - b.order });
    const countData = selectedInstrumentDetail.countData.find(
      (x: any) => x.selected
    );

    const searchFilter = Utility.getUniquePropertiesFromList(
      this.props.selectedInstrumentDetail.properties
    );

    const filteredProps = searchFilter.filter((property) => {
      // search functionality
      return property.name.toLowerCase().includes(this.state.searchValue.toLowerCase());
    });

    let isMeasuring: boolean = false;
    if (
      !this.props.selectedInstrumentDetail.isAutoLine &&
      this.props.selectedInstrumentDetail.status?.name === Status.MEASURING
    ) {
      isMeasuring = true;
    }

    if (this.props.selectedInstrumentDetail.isAutoLine) {
      let filteredPropsDetails = filteredProps;
      filteredPropsDetails.forEach((property: any, index: any) => {
        let meanV;
        if (selectedInstrumentDetail?.readings?.length > 0) {
          meanV =
            selectedInstrumentDetail.readings[0].directionMeans !== undefined
              ? selectedInstrumentDetail.readings[0].directionMeans.find(
                (x: any) =>
                  x.propertyId === property.id &&
                  x.directionId === property.directionId
              )
              : undefined;
        }
        const dirCount =
          this.props.selectedInstrumentDetail.directionCounts.find(
            (x: any) => x.name === countData?.positionName
          );
        var allValueRangesForAPosition: any[] = [];
        this.props.selectedInstrumentDetail.readings.map((x: any) => {
          if (dirCount !== undefined) {
            if (
              x.propertyId === property.id &&
              x.positionName === dirCount.name &&
              x.position === index
            ) {
              allValueRangesForAPosition.push(x);
            }
          }
        });

        var color = this.getRightColorForDashboardView(
          allValueRangesForAPosition
        );
        const meanVal = (meanV === undefined || meanV.mean === 0) ? "(--)" : meanV.mean;
        const meanValue = Math.round(Number(meanVal) * 100) / 100;
        items.push(
          <tr key={index}>
            <td
              className="instrument"
              style={{ padding: "0px", minWidth: "360px" }}
            >
              <table className="innerTable">
                <tr style={{ background: "none" }}>
                  <td className="title">
                    <span className="row pl-0 pr-0">
                      <span className="col-7 pl-0">{property.name}</span>
                      <span className="col-1 pl-0">{property.unit}</span>
                      <span className="col-4 pl-0">
                        {isNaN(meanValue) ||
                          meanValue === null ||
                          meanValue === undefined ? (
                          <span
                            className="val"
                            style={{
                              color: CONSTANTS.WITHIN_LIMIT_COLOR
                            }}
                          >
                            {CONSTANTS.NOTCONSIDEREDFORCALC}
                          </span>
                        ) : (
                          <span
                            className="val"
                            style={{
                              color: CONSTANTS.WITHIN_LIMIT_COLOR
                            }}
                          >
                            ({meanValue?.toFixed(property?.decimals)})
                          </span>
                        )}
                      </span>
                    </span>
                  </td>
                </tr>
              </table>
            </td>

            {this.createMeasuredColumnData(
              property,
              filteredPropsDetails.length,
              index,
              isMeasuring
            )}
          </tr>
        );
      });
    } else {
      selectedDirectionCount.map((elems: any, key: number) => {
        items.push(
          <React.Fragment>
            <br />
            <span
              style={{
                cursor: "pointer",
                fontWeight: this.state.activeDirectionIndx.includes
                  ? "bold"
                  : "normal",
                fontSize: this.state.activeDirectionIndx.includes(elems.id)
                  ? "16px"
                  : "14px",
              }}
              id="directionRow"
              onClick={() => this.onSetActiveDirectionIndx(elems.id)}
            >
              {this.state.activeDirectionIndx.includes(elems.id) ? (
                <Icon className="mr-3" name={ABB_CARET_DOWN} />
              ) : (
                <Icon className="mr-3" name={ABB_CARET_UP} />
              )}
              <b style={{ marginRight: "10px" }}>{elems.name}</b>
            </span>
          </React.Fragment>
        );
        let newrow = key;
        let filteredPropsDetails = filteredProps.filter(
          (elements: any) => elements.directionId === elems.id
        );

        this.state.activeDirectionIndx.includes(elems.id) &&
          filteredPropsDetails.forEach((property: any, index: any) => {
            let meanV;
            if (selectedInstrumentDetail?.readings?.length > 0) {
              meanV =
                selectedInstrumentDetail.readings[0].directionMeans !==
                  undefined
                  ? selectedInstrumentDetail.readings[0].directionMeans.find(
                    (x: any) =>
                      x.propertyId === property.id &&
                      x.directionId === property.directionId
                  )
                  : undefined;
            }
            const dirCount =
              this.props.selectedInstrumentDetail.directionCounts.find(
                (x: any) => x.name === countData?.positionName
              );
            var allValueRangesForAPosition: any[] = [];
            this.props.selectedInstrumentDetail.readings.map((x: any) => {
              if (dirCount !== undefined) {
                if (
                  x.propertyId === property.id &&
                  x.positionName === dirCount.name &&
                  x.position === index
                ) {
                  allValueRangesForAPosition.push(x);
                }
              }
            });

            var color = this.getRightColorForDashboardView(
              allValueRangesForAPosition
            );
            const meanVal = (meanV === undefined || meanV.mean === 0) ? "(--)" : meanV.mean;
            const meanValue = Math.round(Number(meanVal) * 100) / 100;
            items.push(
              <tr
                key={key + "-" + index}
                style={key === newrow ? { borderTop: "2px solid #1f1f1f" } : {}}
              >
                <td
                  className="instrument"
                  style={{ padding: "0px", minWidth: "360px" }}
                >
                  <table className="innerTable">
                    <tr style={{ background: "none" }}>
                      <td className="title">
                        <span className="row pl-0 pr-0">
                          <span className="col-7 pl-0">{property.name}</span>
                          <span className="col-1 pl-0">{property.unit}</span>
                          <span className="col-4 pl-0">
                            {isNaN(meanValue) ||
                              meanValue === null ||
                              meanValue === undefined ? (
                              <span
                                className="val"
                                style={{
                                  color: CONSTANTS.WITHIN_LIMIT_COLOR
                                }}
                              >
                                {CONSTANTS.NOTCONSIDEREDFORCALC}
                              </span>
                            ) : (
                              <span
                                className="val"
                                style={{
                                  color: CONSTANTS.WITHIN_LIMIT_COLOR
                                }}
                              >
                                ({meanValue?.toFixed(property?.decimals)})
                              </span>
                            )}
                          </span>
                        </span>
                      </td>
                    </tr>
                  </table>
                </td>

                {this.createMeasuredColumnData(
                  property,
                  filteredPropsDetails.length,
                  index,
                  isMeasuring,
                  elems.id
                )}
              </tr>
            );
            newrow += 1;
          });
      });
    }
    return items;
  }

  private graphRow() {
    const items: any[] = [];
    const selectedInstrumentDetail = this.props.selectedInstrumentDetail;
    const countData = selectedInstrumentDetail.countData.find(
      (x: any) => x.selected
    );
    let selectedPosition = selectedInstrumentDetail.positionCount.find(
      (x: any) => x.selected
    );

    const searchFilter = Utility.getUniquePropertiesFromList(
      this.props.selectedInstrumentDetail.properties
    );

    const filteredProps = searchFilter.filter((property) => {
      // search functionality
      return property.name.toLowerCase().includes(this.state.searchValue);
    });

    if (this.props.selectedInstrumentDetail.isAutoLine) {
      let selectedDirection: any;

      if (
        selectedInstrumentDetail.countData &&
        selectedInstrumentDetail.countData.length
      ) {
        selectedDirection = selectedInstrumentDetail.countData[0].directions[0];
        selectedDirection.selected = true;
      }

      filteredProps.forEach((property: any, index: any) => {
        let meanV;
        if (selectedInstrumentDetail?.readings?.length > 0) {
          meanV =
            selectedInstrumentDetail.readings[0].directionMeans !== undefined
              ? selectedInstrumentDetail.readings[0].directionMeans.find(
                (x: any) =>
                  x.propertyId === property.id &&
                  x.directionId === property.directionId
              )
              : undefined;
        }
        const dirCount =
          this.props.selectedInstrumentDetail.directionCounts.find(
            (x: any) => x.name === countData?.positionName
          );
        var allValueRangesForAPosition: any[] = [];
        this.props.selectedInstrumentDetail.readings.map((x: any) => {
          if (dirCount !== undefined) {
            if (
              x.propertyId === property.id &&
              x.positionName === dirCount.name &&
              x.position === index
            ) {
              allValueRangesForAPosition.push(x);
            }
          }
        });

        var color = this.getRightColorForDashboardView(
          allValueRangesForAPosition
        );
        const meanVal = (meanV === undefined || meanV.mean === 0) ? "(--)" : meanV.mean;
        const meanValue = Math.round(Number(meanVal) * 100) / 100;

        /*===================================TREND CODE STARTS HERE========================================================*/
        const trendData: any[] = [];
        let propertyDetails: any = {};
        propertyDetails = { ...property };

        for (let index = 0; index < selectedDirection?.maxCount; index++) {
          const readings = this.props.selectedInstrumentDetail.readings;
          // // properties and directionCounts
          let dirC: any[] = [];
          if (selectedDirection.name === "All") {
            dirC = this.props.selectedInstrumentDetail.directionCounts.filter(
              (x: any) =>
                x.position === selectedPosition.position &&
                x.direction.id == property.directionId
            );
          }
          let indexNumber = 0;
          dirC.map((element: any) => {
            const checkDirection = property.name.search(element.direction.name);
            if (checkDirection !== -1) {
              indexNumber = element.totalCounts;
            }
          });
          let mainData;
          if (readings.length > 0) {
            if (selectedDirection.name === "All") {
              if (this.props.selectedInstrumentDetail.isAutoLine) {
                const countData =
                  this.props.selectedInstrumentDetail.countData.find(
                    (x: any) => x.selected === true
                  );
                const dirCount =
                  this.props.selectedInstrumentDetail.directionCounts.find(
                    (x: any) => x.name === countData?.positionName
                  );
                this.props.selectedInstrumentDetail.readings.map((x: any) => {
                  if (
                    x.propertyId === property.id &&
                    x.count === index + 1 &&
                    x.position === dirCount.position &&
                    x.positionName === dirCount.name
                  ) {
                    mainData = x;
                  }
                });
              } else {
                mainData = readings.find(
                  (x: any) =>
                    x.count === index + 1 &&
                    x.propertyId === property.id &&
                    x.position === this.props.selectedPosition.position &&
                    x.directionId === property.directionId
                );
              }
            } else {
              mainData = readings.find(
                (x: any) =>
                  x.count === index + 1 &&
                  x.propertyId === property.id &&
                  x.position === this.props.selectedPosition.position &&
                  x.directionId === selectedDirection.id
              );
            }
          }

          if (mainData !== undefined) {
            if (mainData.valueRange.name === "Alarm Limit1") {
              color = this.props.thresholdSettings.find(
                (x: any) => x.name === "Alarm Limit1"
              )?.colorCode;
            } else if (mainData.valueRange.name === "Alarm Limit2") {
              color = this.props.thresholdSettings.find(
                (x: any) => x.name === "Alarm Limit2"
              )?.colorCode;
            } else if (mainData.valueRange.name === "Reject Limit") {
              color = this.props.thresholdSettings.find(
                (x: any) => x.name === "Reject Limit"
              )?.colorCode;
            }
          }
          if (mainData) {
            trendData.push({
              xValue: (index + 1)?.toString(),
              value: mainData?.value != null ? mainData.value : 0,
            });
          }
        }

        if (trendData.length !== 0) {
          trendData.push({ xValue: "", value: null });
        }

        const yValue: number[] = [
          propertyDetails.alarmLow1,
          propertyDetails.alarmLow2,
          propertyDetails.alarmHigh1,
          propertyDetails.alarmHigh2,
          propertyDetails.rejectLow,
          propertyDetails.rejectHigh,
        ];
        trendData.sort(utility.sortAlphaNum).forEach((item: any) => {
          yValue.push(item.value);
        });

        let minYValue: any = 0;
        let maxYValue: any = 0;

        if (Math.sign(_.min(yValue)) === -1) {
          minYValue = _.min(yValue) + (_.min(yValue) / 100) * 5;
          maxYValue = _.max(yValue) - (_.max(yValue) / 100) * 5;
        } else {
          // ITC Changes
          minYValue = _.min(yValue) - (_.min(yValue) / 100) * 5;
          // const minYValue: any = 0;
          maxYValue = _.max(yValue) + (_.max(yValue) / 100) * 5;
        }
        const series1: ISeries[] = [
          {
            name: "Mean",
            color: "#5ABFAE",
            id: "1",
            markerStyle: {
              type: this.state?.chartType === "Bar" ? "None" : "Circle",
            },
            yAxis: {
              min: minYValue,
              max: maxYValue,
              decimalPlaces: propertyDetails?.decimals,
            },
            dataLimits: [
              {
                name: "Alarm Low Limit-1",
                shownInChart: true,
                value: propertyDetails.alarmLow1,
                className: "custom-line-graph",
                style: {
                  stroke: this.props.thresholdSettings?.find(
                    (x: any) =>
                      x.name === "Alarm Low 1" || x.name === "Alarm Limit1"
                  ).colorCode,
                },
              },
              {
                name: "Alarm High Limit-1",
                shownInChart: true,
                value: propertyDetails.alarmHigh1,
                className: "custom-line-graph",
                style: {
                  stroke: this.props.thresholdSettings?.find(
                    (x: any) =>
                      x.name === "Alarm High 1" || x.name === "Alarm Limit1"
                  ).colorCode,
                },
              },
              {
                name: "Alarm Low Limit-2",
                shownInChart: true,
                value: propertyDetails.alarmLow2,
                className: "custom-line-graph",
                style: {
                  stroke: this.props.thresholdSettings?.find(
                    (x: any) =>
                      x.name === "Alarm Low 2" || x.name === "Alarm Limit2"
                  ).colorCode,
                },
              },
              {
                name: "Alarm High Limit-2",
                shownInChart: true,
                value: propertyDetails.alarmHigh2,
                className: "custom-line-graph",
                style: {
                  stroke: this.props.thresholdSettings?.find(
                    (x: any) =>
                      x.name === "Alarm High 2" || x.name === "Alarm Limit2"
                  ).colorCode,
                },
              },
              {
                name: "Reject Low",
                shownInChart: true,
                value: propertyDetails.rejectLow,
                className: "custom-line-graph",
                style: {
                  stroke: this.props.thresholdSettings?.find(
                    (x: any) =>
                      x.name === "Reject Low" || x.name === "Reject Limit"
                  ).colorCode,
                },
              },
              {
                name: "Reject High",
                shownInChart: true,
                value: propertyDetails.rejectHigh,
                className: "custom-line-graph",
                style: {
                  stroke: this.props.thresholdSettings?.find(
                    (x: any) =>
                      x.name === "Reject High" || x.name === "Reject Limit"
                  ).colorCode,
                },
              },
            ],
            isShownInChart: true,
            points: trendData,
          },
        ];

        let counter = 0;
        items.push(
          <tr key={index}>
            <td className="instrument" style={{ padding: "0px" }}>
              <table className="innerTable">
                <tr style={{ background: "none" }}>
                  <td className="title" style={{ paddingBottom: "114px" }}>
                    <span className="row pl-0 pr-0">
                      <span className="col-7 pl-0">{property.name}</span>
                      <span className="col-1 pl-0">{property.unit}</span>
                      <span className="col-4 pl-0">
                        {isNaN(meanValue) ||
                          meanValue === null ||
                          meanValue === undefined ? (
                          <span
                            className="val"
                            style={{
                              color: CONSTANTS.WITHIN_LIMIT_COLOR
                            }}
                          >
                            {CONSTANTS.NOTCONSIDEREDFORCALC}
                          </span>
                        ) : (
                          <span
                            className="val"
                            style={{
                              color: CONSTANTS.WITHIN_LIMIT_COLOR
                            }}
                          >
                            ({meanValue?.toFixed(property?.decimals)})
                          </span>
                        )}
                      </span>
                    </span>
                  </td>
                </tr>
              </table>
            </td>

            {
              <td className="trend-table" colSpan={7}>
                {series1[0].points?.length > 0 ? (
                  <Trend
                    chartType={this.state.chartType}
                    invalidPointLineType="None"
                    invalidStatuses={["Invalid"]}
                    dateUnit={this.state.dateUnit}
                    dateUnitCount={this.state.dateUnitCount}
                    gridLineColor="grey"
                    gridLineWidth={0.5}
                    showVerticalGridLines={false}
                    showHorizontalGridLines={true}
                    series={series1}
                    xAxis={{ type: "Ordinal", tickAngle: 45, height: 15 }}
                    onChartTypeChange={this.onChartTypeChange}
                    onDataLimitVisibilityChange={
                      this.onDataLimitVisibilityChange
                    }
                    onDateRangeChange={this.onDateRangeChange}
                    onInvalidPointTypeChange={this.onInvalidPointTypeChange}
                    onSeriesChartTypeChange={this.onSeriesChartTypeChange}
                    onSeriesColorChange={this.onSeriesColorChange}
                    onSeriesFillTypeChange={this.onSeriesFillTypeChange}
                    onSeriesMarkerChange={this.onSeriesMarkerChange}
                    trendChartHeight={150}
                    showChartType={false}
                    showDateTimePicker={false}
                    showOuterBorder={false}
                    showTableData={false}
                    yAxisTicksCount={2}
                    yAxisWidth={75}
                  />
                ) : (
                  <div>
                    <NoTrendToDisplay></NoTrendToDisplay>
                  </div>
                )}
              </td>
            }
          </tr>
        );
      });
    } else {
      let selectedDirection: any;
      if (countData !== undefined) {
        selectedDirection = countData.directions.find((x: any) => x.selected);
      }

      if (!selectedDirection && countData) {
        selectedDirection = countData.directions[0];
        selectedDirection.selected = true;
      }

      selectedInstrumentDetail.allDirections.map((elems: any, key: number) => {
        items.push(
          <React.Fragment>
            <br />
            <span
              style={{
                cursor: "pointer",
                fontWeight: this.state.activeDirectionIndx.includes(elems.id)
                  ? "bold"
                  : "normal",
                fontSize: this.state.activeDirectionIndx.includes(elems.id)
                  ? "16px"
                  : "14px",
              }}
              id="directionRow"
              onClick={() => this.onSetActiveDirectionIndx(elems.id)}
            >
              {this.state.activeDirectionIndx.includes(elems.id) ? (
                <Icon className="mr-3" name={ABB_CARET_DOWN} />
              ) : (
                <Icon className="mr-3" name={ABB_CARET_UP} />
              )}
              <b style={{ marginRight: "10px" }}>{elems.name}</b>
            </span>
          </React.Fragment>
        );
        let newrow = key;
        this.state.activeDirectionIndx.includes(elems.id) &&
          filteredProps
            .filter((elements: any) => elements.directionId === elems.id)
            .forEach((property: any, index: any) => {
              let meanV;
              if (selectedInstrumentDetail?.readings?.length > 0) {
                meanV =
                  selectedInstrumentDetail.readings[0].directionMeans !==
                    undefined
                    ? selectedInstrumentDetail.readings[0].directionMeans.find(
                      (x: any) =>
                        x.propertyId === property.id &&
                        x.directionId === property.directionId
                    )
                    : undefined;
              }
              const dirCount =
                this.props.selectedInstrumentDetail.directionCounts.find(
                  (x: any) => x.name === countData?.positionName
                );
              var allValueRangesForAPosition: any[] = [];
              this.props.selectedInstrumentDetail.readings.map((x: any) => {
                if (dirCount !== undefined) {
                  if (
                    x.propertyId === property.id &&
                    x.positionName === dirCount.name &&
                    x.position === index
                  ) {
                    allValueRangesForAPosition.push(x);
                  }
                }
              });

              var color = this.getRightColorForDashboardView(
                allValueRangesForAPosition
              );
              const meanVal = (meanV === undefined || meanV.mean === 0) ? "(--)" : meanV.mean;
              const meanValue = Math.round(Number(meanVal) * 100) / 100;

              /*===================================TREND CODE STARTS HERE========================================================*/
              const trendData: any[] = [];
              let propertyDetails: any = {};
              propertyDetails = { ...property };
              for (let index = 0; index < selectedDirection?.maxCount; index++) {
                const readings = this.props.selectedInstrumentDetail.readings;
                // // properties and directionCounts
                let dirC: any[] = [];
                if (selectedDirection.name === "All") {
                  dirC =
                    this.props.selectedInstrumentDetail.directionCounts.filter(
                      (x: any) =>
                        x.position === selectedPosition.position &&
                        x.direction.id == property.directionId
                    );
                }
                let indexNumber = 0;
                dirC.map((element: any) => {
                  const checkDirection = property.name.search(
                    element.direction.name
                  );
                  if (checkDirection !== -1) {
                    indexNumber = element.totalCounts;
                  }
                });
                let mainData;
                if (readings.length > 0) {
                  if (selectedDirection.name === "All") {
                    if (this.props.selectedInstrumentDetail.isAutoLine) {
                      const countData =
                        this.props.selectedInstrumentDetail.countData.find(
                          (x: any) => x.selected === true
                        );
                      const dirCount =
                        this.props.selectedInstrumentDetail.directionCounts.find(
                          (x: any) => x.name === countData?.positionName
                        );
                      this.props.selectedInstrumentDetail.readings.map(
                        (x: any) => {
                          if (
                            x.propertyId === property.id &&
                            x.count === index + 1 &&
                            x.position === dirCount.position &&
                            x.positionName === dirCount.name
                          ) {
                            mainData = x;
                          }
                        }
                      );
                    } else {
                      mainData = readings.find(
                        (x: any) =>
                          x.count === index + 1 &&
                          x.propertyId === property.id &&
                          x.position === this.props.selectedPosition.position &&
                          x.directionId === property.directionId
                      );
                    }
                  } else {
                    mainData = readings.find(
                      (x: any) =>
                        x.count === index + 1 &&
                        x.propertyId === property.id &&
                        x.position === this.props.selectedPosition.position &&
                        x.directionId === selectedDirection.id
                    );
                  }
                }

                if (mainData !== undefined) {
                  if (mainData.valueRange.name === "Alarm Limit1") {
                    color = this.props.thresholdSettings.find(
                      (x: any) => x.name === "Alarm Limit1"
                    )?.colorCode;
                  } else if (mainData.valueRange.name === "Alarm Limit2") {
                    color = this.props.thresholdSettings.find(
                      (x: any) => x.name === "Alarm Limit2"
                    )?.colorCode;
                  } else if (mainData.valueRange.name === "Reject Limit") {
                    color = this.props.thresholdSettings.find(
                      (x: any) => x.name === "Reject Limit"
                    )?.colorCode;
                  }
                }
                if (mainData) {
                  trendData.push({
                    xValue: (index + 1)?.toString(),
                    value: mainData?.value != null ? mainData.value : 0,
                  });
                }
              }

              if (trendData.length !== 0) {
                trendData.push({ xValue: "", value: null });
              }

              const yValue: number[] = [
                propertyDetails.alarmLow1,
                propertyDetails.alarmLow2,
                propertyDetails.alarmHigh1,
                propertyDetails.alarmHigh2,
                propertyDetails.rejectLow,
                propertyDetails.rejectHigh,
              ];
              trendData.sort(utility.sortAlphaNum).forEach((item: any) => {
                yValue.push(item.value);
              });

              let minYValue: any = 0;
              let maxYValue: any = 0;

              if (Math.sign(_.min(yValue)) === -1) {
                minYValue = _.min(yValue) + (_.min(yValue) / 100) * 5;
                maxYValue = _.max(yValue) - (_.max(yValue) / 100) * 5;
              } else {
                // ITC Changes
                minYValue = _.min(yValue) - (_.min(yValue) / 100) * 5;
                // const minYValue: any = 0;
                maxYValue = _.max(yValue) + (_.max(yValue) / 100) * 5;
              }
              const series1: ISeries[] = [
                {
                  name: "Mean",
                  color: "#5ABFAE",
                  id: "1",
                  markerStyle: {
                    type: this.state?.chartType === "Bar" ? "None" : "Circle",
                  },
                  yAxis: {
                    min: minYValue,
                    max: maxYValue,
                    decimalPlaces: propertyDetails?.decimals,
                  },
                  dataLimits: [
                    {
                      name: "Alarm Low Limit-1",
                      shownInChart: true,
                      value: propertyDetails.alarmLow1,
                      className: "custom-line-graph",
                      style: {
                        stroke: this.props.thresholdSettings?.find(
                          (x: any) =>
                            x.name === "Alarm Low 1" ||
                            x.name === "Alarm Limit1"
                        ).colorCode,
                      },
                    },
                    {
                      name: "Alarm High Limit-1",
                      shownInChart: true,
                      value: propertyDetails.alarmHigh1,
                      className: "custom-line-graph",
                      style: {
                        stroke: this.props.thresholdSettings?.find(
                          (x: any) =>
                            x.name === "Alarm High 1" ||
                            x.name === "Alarm Limit1"
                        ).colorCode,
                      },
                    },
                    {
                      name: "Alarm Low Limit-2",
                      shownInChart: true,
                      value: propertyDetails.alarmLow2,
                      className: "custom-line-graph",
                      style: {
                        stroke: this.props.thresholdSettings?.find(
                          (x: any) =>
                            x.name === "Alarm Low 2" ||
                            x.name === "Alarm Limit2"
                        ).colorCode,
                      },
                    },
                    {
                      name: "Alarm High Limit-2",
                      shownInChart: true,
                      value: propertyDetails.alarmHigh2,
                      className: "custom-line-graph",
                      style: {
                        stroke: this.props.thresholdSettings?.find(
                          (x: any) =>
                            x.name === "Alarm High 2" ||
                            x.name === "Alarm Limit2"
                        ).colorCode,
                      },
                    },
                    {
                      name: "Reject Low",
                      shownInChart: true,
                      value: propertyDetails.rejectLow,
                      className: "custom-line-graph",
                      style: {
                        stroke: this.props.thresholdSettings?.find(
                          (x: any) =>
                            x.name === "Reject Low" || x.name === "Reject Limit"
                        ).colorCode,
                      },
                    },
                    {
                      name: "Reject High",
                      shownInChart: true,
                      value: propertyDetails.rejectHigh,
                      className: "custom-line-graph",
                      style: {
                        stroke: this.props.thresholdSettings?.find(
                          (x: any) =>
                            x.name === "Reject High" ||
                            x.name === "Reject Limit"
                        ).colorCode,
                      },
                    },
                  ],
                  isShownInChart: true,
                  points: trendData,
                },
              ];

              let counter = 0;
              items.push(
                <tr
                  key={key + "-" + index}
                  style={
                    key === newrow ? { borderTop: "2px solid #1f1f1f" } : {}
                  }
                >
                  <td className="instrument" style={{ padding: "0px" }}>
                    <table className="innerTable">
                      <tr style={{ background: "none" }}>
                        <td
                          className="title"
                          style={{ paddingBottom: "114px" }}
                        >
                          <span className="row pl-0 pr-0">
                            <span className="col-7 pl-0">{property.name}</span>
                            <span className="col-1 pl-0">{property.unit}</span>
                            <span className="col-4 pl-0">
                              {isNaN(meanValue) ||
                                meanValue === null ||
                                meanValue === undefined ? (
                                <span
                                  className="val"
                                  style={{
                                    color: CONSTANTS.WITHIN_LIMIT_COLOR
                                  }}
                                >
                                  {CONSTANTS.NOTCONSIDEREDFORCALC}
                                </span>
                              ) : (
                                <span
                                  className="val"
                                  style={{
                                    color: CONSTANTS.WITHIN_LIMIT_COLOR
                                  }}
                                >
                                  ({meanValue?.toFixed(property?.decimals)})
                                </span>
                              )}
                            </span>
                          </span>
                        </td>
                      </tr>
                    </table>
                  </td>

                  {
                    <td className="trend-table" colSpan={7}>
                      {series1[0].points?.length > 0 ? (
                        <Trend
                          chartType={this.state.chartType}
                          invalidPointLineType="None"
                          invalidStatuses={["Invalid"]}
                          dateUnit={this.state.dateUnit}
                          dateUnitCount={this.state.dateUnitCount}
                          gridLineColor="grey"
                          gridLineWidth={0.5}
                          showVerticalGridLines={false}
                          showHorizontalGridLines={true}
                          series={series1}
                          xAxis={{ type: "Ordinal", tickAngle: 45, height: 15 }}
                          onChartTypeChange={this.onChartTypeChange}
                          onDataLimitVisibilityChange={
                            this.onDataLimitVisibilityChange
                          }
                          onDateRangeChange={this.onDateRangeChange}
                          onInvalidPointTypeChange={
                            this.onInvalidPointTypeChange
                          }
                          onSeriesChartTypeChange={this.onSeriesChartTypeChange}
                          onSeriesColorChange={this.onSeriesColorChange}
                          onSeriesFillTypeChange={this.onSeriesFillTypeChange}
                          onSeriesMarkerChange={this.onSeriesMarkerChange}
                          trendChartHeight={150}
                          showChartType={false}
                          showDateTimePicker={false}
                          showOuterBorder={false}
                          showTableData={false}
                          yAxisTicksCount={2}
                          yAxisWidth={75}
                        />
                      ) : (
                        <div>
                          <NoTrendToDisplay></NoTrendToDisplay>
                        </div>
                      )}
                    </td>
                  }
                </tr>
              );
              newrow += 1;
            });
      });
    }
    return items;
  }

  private createMeasuredColumnGraphData = (propertyToDisplay: any) => {
    const items: any[] = [];
    let countData = this.props.selectedInstrumentDetail.countData.find(
      (x: any) => x.selected
    );
    if (!countData) {
      countData = this.props.selectedInstrumentDetail.countData[0];
    }
    let selectedDirection: any;
    if (countData !== undefined) {
      selectedDirection = countData.directions.find((x: any) => x.selected);
    }
    let selectedPosition =
      this.props.selectedInstrumentDetail.positionCount.find(
        (x: any) => x.selected
      );
    if (!selectedPosition) {
      selectedPosition = this.props.selectedInstrumentDetail.positionCount[0];
    }

    let properties = [];
    const filteredProps = Utility.getUniquePropertiesFromList(
      this.props.selectedInstrumentDetail.properties
    );

    properties = filteredProps.filter((x) => {
      if (selectedDirection !== undefined) {
        if (selectedDirection.name === "All") {
          return x;
        } else {
          return x.directionId === selectedDirection.id;
        }
      } else {
        if (x.name === "All") {
          return x;
        } else {
          return x;
        }
      }
    });

    properties = properties.filter((x: any) => x.id === propertyToDisplay.id);

    if (selectedPosition !== undefined) {
      properties.map((data: any, index) => {
        if (
          this.state.selectedDirection[0].value === "All" ||
          data.directionId === this.state.selectedDirection[0].value
        ) {
          const cpProperty =
            this.props.selectedInstrumentDetail.currentMeasuringProperty;
          const cpPosition =
            this.props.selectedInstrumentDetail.currentMeasuringPosition;

          let temp = this.createGraphData(
            data.id,
            data.name,
            selectedDirection,
            this.props.selectedPosition,
            data.directionId,
            cpPosition
          );
        }
      });
    }
    return items;
  };

  public createGraphData(
    propertyId: any,
    propertyName: string,
    selectedDirection: any,
    selectedPosition: any,
    directionId?: string,
    cpPosition?: number
  ) {
    const items: any[] = [];
    if (selectedDirection !== undefined) {
      for (let index = 0; index < selectedDirection?.maxCount; index++) {
        const readings = this.props.selectedInstrumentDetail.readings;
        // // properties and directionCounts
        let dirC: any[] = [];
        if (selectedDirection.name === "All") {
          dirC = this.props.selectedInstrumentDetail.directionCounts.filter(
            (x: any) =>
              x.position === selectedPosition.position &&
              x.direction.id == directionId
          );
        }
        let indexNumber = 0;
        dirC.map((element: any) => {
          const checkDirection = propertyName.search(element.direction.name);
          if (checkDirection !== -1) {
            indexNumber = element.totalCounts;
          }
        });
        let mainData;
        if (readings.length > 0) {
          if (selectedDirection.name === "All") {
            if (this.props.selectedInstrumentDetail.isAutoLine) {
              const countData =
                this.props.selectedInstrumentDetail.countData.find(
                  (x: any) => x.selected === true
                );
              const dirCount =
                this.props.selectedInstrumentDetail.directionCounts.find(
                  (x: any) => x.name === countData?.positionName
                );
              this.props.selectedInstrumentDetail.readings.map((x: any) => {
                if (
                  x.propertyId === propertyId &&
                  x.count === index + 1 &&
                  x.position === dirCount.position &&
                  x.positionName === dirCount.name
                ) {
                  mainData = x;
                }
              });
            } else {
              mainData = readings.find(
                (x: any) =>
                  x.count === index + 1 &&
                  x.propertyId === propertyId &&
                  x.position === selectedPosition.position &&
                  x.directionId === directionId
              );
            }
          } else {
            mainData = readings.find(
              (x: any) =>
                x.count === index + 1 &&
                x.propertyId === propertyId &&
                x.directionId === selectedDirection.id &&
                x.position === selectedPosition.position
            );
          }
        }

        const data =
          mainData !== undefined &&
            mainData.value != null &&
            !isNaN(mainData.value)
            ? mainData.value.toFixed(mainData.decimals)
            : indexNumber <= index
              ? CONSTANTS.NOTCONSIDEREDFORCALC
              : CONSTANTS.NOTCONSIDEREDFORCALC;
        let color = "black";
        if (mainData !== undefined) {
          if (mainData.valueRange.name === "Alarm Limit1") {
            color = this.props.thresholdSettings.find(
              (x: any) => x.name === "Alarm Limit1"
            )?.colorCode;
          } else if (mainData.valueRange.name === "Alarm Limit2") {
            color = this.props.thresholdSettings.find(
              (x: any) => x.name === "Alarm Limit2"
            )?.colorCode;
          } else if (mainData.valueRange.name === "Reject Limit") {
            color = this.props.thresholdSettings.find(
              (x: any) => x.name === "Reject Limit"
            )?.colorCode;
          } else if (mainData.valueRange.name === "Within Limit") {
            color = CONSTANTS.WITHIN_LIMIT_BG_COLOR;
          }
        }

        let pos = this.props.selectedInstrumentDetail.countData.find(
          (x: any) => x.position === selectedPosition.position
        );
        let dir = pos.directions.find((x: any) => x.id === directionId);

        return data;
      }
    }
  }

  private startPositionRemasureAfterConfirm = () => {
    if (
      this.state.reMeasureDirection.length &&
      this.state.reMeasureCount.length
    ) {
      if (
        this.state.reMeasureDirection[0].value === "All" &&
        this.state.reMeasureCount[0].value === 0
      ) {
        const directions: any[] = this.state.dropdownDirectionOptions
          .filter((ele: any) => ele.value !== "All")
          .map((el: any) => {
            return el.value;
          });
        let countDataList = this.props.selectedInstrumentDetail.countData.find(
          (x: any) => x.position === this.props.selectedPosition.position
        );
        if (!countDataList) {
          countDataList = this.props.selectedInstrumentDetail.countData[0];
        }
        let selectedDirection: any;
        if (countDataList !== undefined) {
          selectedDirection = countDataList.directions.find(
            (x: any) => x.selected
          );
        }

        const countList = selectedDirection?.maxCount ?? 0;
        const count: any[] = [];
        for (let i = 0; i < countList; i++) {
          count.push(i + 1);
        }
        this.props.reMeasureDirectionPositionCountAll(
          this.props.selectedInstrumentDetail.id,
          directions,
          this.props.selectedPosition?.position ?? 0,
          count
        );
      } else if (
        this.state.reMeasureDirection[0].value === "All" ||
        this.state.reMeasureCount[0].value === 0
      ) {
        const directions: any[] =
          this.state.reMeasureDirection[0].value === "All"
            ? this.state.dropdownDirectionOptions
              .filter((ele: any) => ele.value !== "All")
              .map((el: any) => {
                return el.value;
              })
            : [this.state.reMeasureDirection[0].value];

        let count: any[] = [];
        if (this.state.reMeasureCount[0].value === 0) {
          let countDataList =
            this.props.selectedInstrumentDetail.countData.find(
              (x: any) => x.position === this.props.selectedPosition.position
            );
          if (!countDataList) {
            countDataList = this.props.selectedInstrumentDetail.countData[0];
          }
          let selectedDirection: any;
          if (countDataList) {
            selectedDirection = countDataList.directions.find(
              (x: any) => x.id === this.state.reMeasureDirection[0].value
            );
          }

          const countList = selectedDirection?.maxCount ?? 0;
          for (let i = 0; i < countList; i++) {
            count.push(i + 1);
          }
        } else {
          count = [this.state.reMeasureCount[0].value];
        }
        this.props.reMeasureDirectionPositionCountSingleAll(
          this.props.selectedInstrumentDetail.id,
          this.state.reMeasureDirection[0].value,
          this.props.selectedPosition?.position ?? 0,
          this.state.reMeasureCount[0].value,
          directions,
          count
        );
      } else {
        this.props.reMeasureDirectionPositionCount(
          this.props.selectedInstrumentDetail.id,
          this.state.reMeasureDirection[0].value,
          this.props.selectedPosition?.position ?? 0,
          this.state.reMeasureCount[0].value,
          true
        );
      }
      this.setState({
        showPositionCountRemasure: false,
      });
    } else {
      triggerNotifications.error("Please select all the fields.");
      return;
    }
  };

  private skipCountsAfterConfirm = (selectedDirection: any) => {
    if (this.state.skipCountsDetails && this.state.skipCountsDetails.length) {
      const completedCounts = selectedDirection.completedCounts;

      let countDetails: any[] = [];
      const measuredCounts = [...selectedDirection.measurementCounts, ...selectedDirection.skippedDetails]
      countDetails = Array.from({length: selectedDirection.totalCounts}, (_, i) => i + 1)
        .filter((item:any) => item <= this.state.skipCountsDetails[0].value && !measuredCounts.includes(item));

      this.props.skipCountInPosition(
        this.props.selectedInstrumentDetail.id || "",
        this.props.selectedPosition?.position ?? 0,
        selectedDirection?.id ?? "",
        countDetails || []
      );
    }
    this.setState({
      showSkipCount: false,
      skipCountsDetails: [],
    });
  };

  render() {
    const { selectedInstrumentDetail } = this.props;

    let countDataList = this.props.selectedInstrumentDetail.countData.find(
      (x: any) => x.position === this.props.selectedPosition?.position
    );
    if (!countDataList) {
      countDataList = this.props.selectedInstrumentDetail.countData[0];
    }
    let selectedDirection: any;
    if (countDataList !== undefined) {
      selectedDirection = countDataList.directions.find((x: any) => x.selected);
    }

    const countList = selectedDirection?.maxCount ?? 0;
    let Header: JSX.Element[] = [];
    if (countList) {
      if (!this.state.toggleGraph) {
        Header.push(<th className="normal-class text-align-center">Avg</th>);
        for (let i = 0; i < countList; i++) {
          Header.push(
            <th className="normal-class text-align-center">
              <span> {i + 1}</span>
            </th>
          );
        }
      } else {
        Header.push(<th className="normal-class text-align-center"></th>);
        for (let i = 0; i < countList; i++) {
          Header.push(<th className="normal-class text-align-center"></th>);
        }
      }
    }

    let DirectionDropdown: any[] = [];
    let countDropDown: any[] = [];
    const measuredDirectionList =
      this.props.selectedInstrumentDetail?.countData.find(
        (x: any) =>
          x.position === Number(this.props.selectedPosition?.position ?? 0)
      );
    if (measuredDirectionList && measuredDirectionList.directions) {
      (measuredDirectionList.directions || []).forEach((item: any) => {
        if (item.name !== "All" && item.completedCounts) {
          DirectionDropdown.push({ label: item.name, value: item.id });
        }
      });
      if (
        this.state.reMeasureDirection &&
        this.state.reMeasureDirection.length
      ) {
        if (this.state.reMeasureDirection[0].value === "All") {
          const findAllDirecion = (measuredDirectionList.directions || []).find(
            (el: any) => el.name === "All"
          );
          if (
            findAllDirecion &&
            findAllDirecion.totalCounts === findAllDirecion.completedCounts
          ) {
            countDropDown = [-1];
            for (let j = 0; j < findAllDirecion.maxCount; j++) {
              countDropDown.push(j);
            }
          }
        } else {
          const findAllDirecion = (measuredDirectionList.directions || []).find(
            (el: any) => el.id === this.state.reMeasureDirection[0].value
          );
          if (findAllDirecion && findAllDirecion.completedCounts) {
            countDropDown =
              findAllDirecion.totalCounts === findAllDirecion.completedCounts
                ? [-1]
                : [];
            // for (let j = 0; j < findAllDirecion.completedCounts; j++) {
            //   countDropDown.push(j);
            // }
            countDropDown.push(...findAllDirecion.measurementCounts, ...findAllDirecion.skippedDetails);
            countDropDown.sort((a, b) => a - b);
          }
        }
      }
    }
    countDropDown = countDropDown.filter((value, index, self) => self.indexOf(value) === index);
    
    let skipCountgDropdown: any[] = [];
    const MeasuringDirection = countDataList.directions.find(
      (x: any) =>
        x.id ===
        this.props.selectedInstrumentDetail.nextMeasuringPositionDireaction
          ?.directionId
    );
    if (
      this.props.selectedInstrumentDetail &&
      this.props.selectedPosition &&
      MeasuringDirection &&
      this.props.selectedInstrumentDetail.nextMeasuringPositionDireaction &&
      this.props.selectedInstrumentDetail.nextMeasuringPositionDireaction
        .position === this.props.selectedPosition.position
    ) {
      const totalCounts = MeasuringDirection.totalCounts;
      const completedCounts = MeasuringDirection.completedCounts;
      const measuredCounts = [...MeasuringDirection.measurementCounts, ...MeasuringDirection.skippedDetails]
      for (let k = 1; k <= totalCounts; k++) {
        if (!measuredCounts.includes(k)) {
          skipCountgDropdown.push({
            value: k,
            label: k,
            disabled: false,
          });
        }
      }
    }

    return (
      <Translation>
        {(t) => (
          <React.Fragment>
            <div className="col-12">
              <button
                title="back"
                className="icon-button circle "
                onClick={(e: any) =>
                  this.props.showInstrumentPropertyDetails(
                    this.props.selectedInstrumentDetail
                  )
                }
              >
                <Icon name="abb/left" sizeClass="small" />
              </button>
              <b className="instrument-name-in-property">
                {selectedInstrumentDetail?.name ?? ""}
              </b>
              <ul className="navbar-nav propertyFilterList">
                <li className="position-relative">
                  <button title="search" className="searchIcon icon-button">
                    <Icon name="abb/search" sizeClass="small" />
                  </button>
                  <input
                    type="text"
                    className="searchInput"
                    placeholder={t(CONSTANTS.LABEL_SEARCH_PROPERTY)}
                    value={this.state.searchValue}
                    onChange={this.searchHandler}
                  />
                </li>
                <li>
                  {this.state.toggleGraph ? (
                    <button
                      title={t(CONSTANTS.TITLE_TESTOVERVIEW_DETAILS)}
                      className={
                        this.state.toggleGraph
                          ? "icon-button circle active"
                          : "icon-button circle"
                      }
                      onClick={this.toggleGraphView}
                    >
                      <Icon name="abb/list" sizeClass="small" />
                    </button>
                  ) : (
                    <button
                      title={t(CONSTANTS.TITLE_TESTOVERVIEW_GRAPH)}
                      className={
                        this.state.toggleGraph
                          ? "icon-button circle active"
                          : "icon-button circle"
                      }
                      onClick={this.toggleGraphView}
                    >
                      <Icon name="abb/trend-3" sizeClass="small" />
                    </button>
                  )}
                </li>
              </ul>
              <div className="divider"></div>
              <div className="table-data-container1" id="tableScroll">
                <table className="table propertyTable table-striped">
                  <thead>
                    <tr>
                      <th
                        className="instrument"
                        style={{ padding: "0px", minWidth: "360px" }}
                      >
                        <table>
                          <tr>
                            <th
                              className="property px-0"
                              style={{ minWidth: "160px" }}
                            >
                              <div className="measureItems mx-0 cursor-default">
                                <div className="details">
                                  <p className="title">
                                    {this.props.selectedPosition?.positionName}
                                  </p>
                                  {this.props.selectedInstrumentDetail
                                    ?.isAutoLine ? (
                                    <p className="statusGray">
                                      {
                                        this.props.selectedInstrumentDetail
                                          .status.name
                                      }
                                    </p>
                                  ) : this.props.selectedPosition.directions[0]
                                    .totalCounts &&
                                    (this.props.selectedPosition.directions[0]
                                      ?.completedCounts ?? 0) ===
                                    this.props.selectedPosition.directions[0]
                                      .totalCounts ? (
                                    <p className="statusGreen">
                                      {t(Status.COMPLETED)}
                                    </p>
                                  ) : (
                                    <p className="statusGray">
                                      {t(Status.MEASURING)}
                                    </p>
                                  )}

                                  <p>
                                    {this.props.selectedPosition.directions[0]
                                      ?.completedCounts ?? 0}{" "}
                                    (
                                    {
                                      this.props.selectedPosition.directions[0]
                                        .totalCounts
                                    }
                                    )
                                  </p>
                                </div>
                                {!this.props.selectedInstrumentDetail
                                  .isAutoLine && (
                                    <span className="buttons-in-property-details">
                                      <button
                                        title={CONSTANTS.BUTTON_REMEASURE}
                                        className="icon-button circle btn-40 m-0 button-actions"
                                        style={{
                                          padding: "10px",
                                          backgroundColor: "#dee2e6",
                                        }}
                                        onClick={() => {
                                          this.setState({
                                            showPositionCountRemasure: true,
                                            showSkipCount: false,
                                            reMeasureDirection: [],
                                            reMeasureCount: [],
                                          }, () => {
                                            this.props.onRemeasureClick()
                                          });
                                        }}
                                        disabled={
                                          (this.props.selectedPosition?.directions[0]?.completedCounts ?? 0) === 0
                                          || this.props.activeItem.status.name === Status.STOPPED || this.props.activeItem.status.name === Status.PAUSED || (
                                            this.props.activeItem.status.name === Status.MEASURED
                                            && this.props.selectedInstrumentDetail.status.name === Status.COMPLETED
                                          )
                                        }
                                      >
                                        <Icon
                                          name={"abb/refresh"}
                                          sizeClass="small"
                                          className={
                                            (this.props.selectedPosition?.directions[0]?.completedCounts ?? 0) === 0
                                              || this.props.activeItem.status.name === Status.STOPPED || this.props.activeItem.status.name === Status.PAUSED || (
                                                this.props.activeItem.status.name === Status.MEASURED
                                                && this.props.selectedInstrumentDetail.status.name === Status.COMPLETED
                                              )
                                              ? "iconDisabled"
                                              : ""
                                          }
                                        />
                                      </button>
                                      <button
                                        title={t(CONSTANTS.BUTTON_END_POSITION)}
                                        className="icon-button circle btn-40 m-0 button-actions"
                                        style={{
                                          padding: "10px",
                                          backgroundColor: "#dee2e6",
                                        }}
                                        onClick={() => {
                                          this.props.endPosition(
                                            this.props.selectedInstrumentDetail
                                              .id || "",
                                            this.props.selectedPosition
                                              ?.position ?? 0
                                          );
                                        }}
                                        disabled={
                                          this.props.selectedInstrumentDetail
                                            .nextMeasuringPositionDireaction
                                            .position !==
                                          this.props.selectedPosition.position ||
                                          this.props.selectedPosition.directions.every((item: any) => item.completedCounts === item.totalCounts)
                                          || this.props.activeItem.status.name === Status.STOPPED || this.props.activeItem.status.name === Status.PAUSED
                                        }
                                      >
                                        <Icon
                                          name={"abb/skip-to-end"}
                                          sizeClass="small"
                                          className={
                                            (this.props.selectedInstrumentDetail
                                              .nextMeasuringPositionDireaction
                                              .position !==
                                            this.props.selectedPosition.position ||
                                            this.props.selectedPosition.directions.every((item: any) => item.completedCounts === item.totalCounts)
                                            || this.props.activeItem.status.name === Status.STOPPED || this.props.activeItem.status.name === Status.PAUSED)
                                              ? "iconDisabled"
                                              : ""
                                          }
                                        />
                                      </button>
                                      <button
                                        title={CONSTANTS.BUTTON_SKIP_COUNT}
                                        className="icon-button circle btn-40 m-0 button-actions"
                                        style={{
                                          padding: "10px",
                                          backgroundColor: "#dee2e6",
                                        }}
                                        onClick={() => {
                                          this.setState({
                                            showSkipCount: true,
                                            showPositionCountRemasure: false,
                                            skipCountsDetails: [],
                                          }, () => {
                                            this.props.onRemeasureClick()
                                          });
                                        }}
                                        disabled={
                                          this.props.selectedInstrumentDetail
                                            .nextMeasuringPositionDireaction
                                            .position !==
                                          this.props.selectedPosition.position ||
                                          this.props.selectedPosition.directions.every((item: any) => item.completedCounts === item.totalCounts)
                                          || this.props.activeItem.status.name === Status.STOPPED || this.props.activeItem.status.name === Status.PAUSED
                                        }
                                      >
                                        <Icon
                                          name={"abb/double-right"}
                                          sizeClass="small"
                                          className={
                                            (this.props.selectedInstrumentDetail
                                              .nextMeasuringPositionDireaction
                                              .position !==
                                            this.props.selectedPosition.position ||
                                            this.props.selectedPosition.directions.every((item: any) => item.completedCounts === item.totalCounts)
                                            || this.props.activeItem.status.name === Status.STOPPED || this.props.activeItem.status.name === Status.PAUSED)
                                              ? "iconDisabled"
                                              : ""
                                          }
                                        />
                                      </button>
                                    </span>
                                  )}

                                {this.state.valueStatus && (
                                  <progress
                                    value={
                                      this.props.selectedPosition.directions[0]
                                        ?.completedCounts ?? 0
                                    }
                                    max={
                                      this.props.selectedPosition.directions[0]
                                        .totalCounts
                                    }
                                  ></progress>
                                )}
                              </div>
                            </th>
                          </tr>
                        </table>
                      </th>
                      {countList ? (
                        Header.map((el) => {
                          return el;
                        })
                      ) : (
                        <></>
                      )}
                    </tr>
                  </thead>
                  {!this.state.toggleGraph ? (
                    <tbody>{this.measuredRow()}</tbody>
                  ) : (
                    <tbody>{this.graphRow()}</tbody>
                  )}
                </table>
              </div>
            </div>

            {/* Remeasure Popup */}
            <Dialog
              isOpen={this.state.showPositionCountRemasure}
              onClose={() =>
                this.setState({ showPositionCountRemasure: false })
              }
              showCloseButton={true}
              closeOnEscape={false}
              closeOnLostFocus={false}
              dimBackground={true}
              title={`${t("Remeasure")} Position ${this.props.selectedPosition &&
                this.props.selectedPosition.position >= 0
                ? Number(this.props.selectedPosition.position) + 1
                : 0
                }`}
              standardButtonsOnBottom={[
                {
                  text: t(CONSTANTS.BUTTON_CANCEL),
                  type: "discreet-blue",
                  handler: (dlg) => dlg.close(),
                },
                {
                  text: t(CONSTANTS.BUTTON_OK),
                  type: "primary-blue",
                  handler: this.startPositionRemasureAfterConfirm,
                },
              ]}
            >
              <div>
                <Dropdown
                  placeholder={t("Select Direction")}
                  value={this.state.reMeasureDirection}
                  onChange={(val) => {
                    this.setState({
                      reMeasureDirection: val,
                      reMeasureCount: [],
                    });
                  }}
                  initialOpen={false}
                  className="searchDropdown-Remeasure-postion-count"
                >
                  {DirectionDropdown.map((o: any) => (
                    <DropdownOption
                      key={o.value}
                      label={o.label}
                      value={o.value}
                    />
                  ))}
                </Dropdown>
                <br />
                <Dropdown
                  placeholder="Select Count"
                  value={this.state.reMeasureCount}
                  onChange={(val) => {
                    this.setState({ reMeasureCount: val });
                  }}
                  initialOpen={false}
                  className="searchDropdown-Remeasure-postion-count"
                >
                  {countDropDown.map((o: any) => (
                    <DropdownOption
                      key={o === -1 ? "All" : o}
                      label={(o === -1 ? "All" : o).toString()}
                      value={(o === -1 ? 0 : o)}
                    />
                  ))}
                </Dropdown>
              </div>
            </Dialog>

            {/* Skip Count */}
            <Dialog
              isOpen={this.state.showSkipCount}
              onClose={() => this.setState({ showSkipCount: false })}
              showCloseButton={true}
              closeOnEscape={false}
              closeOnLostFocus={false}
              dimBackground={true}
              title={`Position ${this.props.selectedPosition &&
                this.props.selectedPosition.position >= 0
                ? Number(this.props.selectedPosition.position) + 1
                : 0
                } ${t("Skip Count Till")}`}
              standardButtonsOnBottom={[
                {
                  text: t(CONSTANTS.BUTTON_CANCEL),
                  type: "discreet-blue",
                  handler: (dlg) => dlg.close(),
                },
                {
                  text: t(CONSTANTS.BUTTON_OK),
                  type: "primary-blue",
                  handler: () => {
                    this.skipCountsAfterConfirm(MeasuringDirection);
                  },
                },
              ]}
            >
              <div>
                <Dropdown
                  placeholder="Select Count"
                  value={this.state.skipCountsDetails}
                  onChange={(val) => {
                    this.setState({ skipCountsDetails: val });
                  }}
                  initialOpen={false}
                  className="searchDropdown-Remeasure-postion-count"
                  searchable={true}
                  multiselect={false}
                  allowAdd={false}
                  clearable={true}
                >
                  {(skipCountgDropdown || []).map((o: any) => (
                    <DropdownOption
                      key={o.value}
                      label={o.label?.toString()}
                      value={o.value}
                      disabled={o.disabled}
                    />
                  ))}
                </Dropdown>
              </div>
            </Dialog>
          </React.Fragment>
        )}
      </Translation>
    );
  }
}
